export enum HostProfileStatus {
	NEW = "NEW",
	RESUBMIT = "RESUBMIT",
	APPROVED = "APPROVED",
	REJECTED = "REJECTED",
}
